import useSignOut from "../useQuery/user/useSignOut";

export default function Logout(){
    const logoutHandler = useSignOut();
    logoutHandler();
    return (<></>)
}